import * as Env from '@zg-rentals/rental-platform-config';

export class FrontendEnvironmentConfig<T> {
  private readonly defaultValue: T;
  private prodValue: T | null;
  private stagingValue: T | null;

  constructor(defaultValue: T) {
    this.defaultValue = defaultValue;
    this.prodValue = null;
    this.stagingValue = null;
  }

  public withProdValue(value: T): FrontendEnvironmentConfig<T> {
    this.prodValue = value;
    return this;
  }

  public withStagingValue(value: T): FrontendEnvironmentConfig<T> {
    this.stagingValue = value;
    return this;
  }

  public getValue(): T {
    if (Env.getCurrentEnvForClientSide() === Env.PRODUCTION && this.prodValue !== null) {
      return this.prodValue;
    }
    if (
      (Env.getCurrentEnvForClientSide() === Env.STAGING || Env.getCurrentEnvForClientSide() === Env.COMET_1) &&
      this.stagingValue !== null
    ) {
      return this.stagingValue;
    }
    return this.defaultValue;
  }
}
